import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { cn } from "@/lib/utils";

function useCountdown(endTime) {
    const [remaining, setRemaining] = useState(() => Math.max(0, new Date(endTime).getTime() - Date.now()));
    useEffect(() => {
        const id = setInterval(() => {
            setRemaining(Math.max(0, new Date(endTime).getTime() - Date.now()));
        }, 1000);
        return () => clearInterval(id);
    }, [endTime]);
    return remaining;
}

export function formatRemaining(ms) {
    if (ms <= 0) return "Ended";
    const s = Math.floor(ms / 1000);
    const d = Math.floor(s / 86400);
    const h = Math.floor((s % 86400) / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = s % 60;
    if (d > 0) return `${d}d ${h}h ${m}m`;
    if (h > 0) return `${h}h ${m}m ${sec}s`;
    return `${m}m ${sec}s`;
}

export const CountdownPill = ({ endTime, status, className }) => {
    const remaining = useCountdown(endTime);
    const ended = status !== "OPEN" || remaining <= 0;
    const urgent = !ended && remaining < 10 * 60 * 1000;
    const label = ended ? "Auction ended" : `Time remaining: ${formatRemaining(remaining)}`;
    return (
        <span
            data-testid="countdown-pill"
            role="status"
            aria-label={label}
            className={cn(
                "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-display tabular-nums",
                ended ? "bg-secondary text-secondary-foreground border-border" : "bg-card text-foreground border-border",
                urgent && "border-warning/50 text-warning",
                className
            )}
        >
            {urgent && <span className="h-1.5 w-1.5 rounded-full bg-warning animate-pulse" aria-hidden />}
            <Clock className="h-3.5 w-3.5" aria-hidden />
            <span data-testid="countdown-pill-time">{ended ? "Ended" : formatRemaining(remaining)}</span>
        </span>
    );
};
